import { PregnancyCompletionType } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { assertUnreachable, FormContextValues } from '@dreryk/react-common';

import { GynecologicalInterviewPregnancyCompletionFormController } from './gynecologicalInterviewAddEntryForm.types';
import { GynecologicalInterviewType } from './GynecologicalInterviewTypeSelect';

const pregnancyCompletionTypes: PregnancyCompletionType[] = ['DELIVERY', 'DEAD_DELIVERY', 'MISCARRIAGE', 'OTHER'];
export const isPregnancyCompletionForm = (
   interviewType: GynecologicalInterviewType | null,
   handleSubmit: FormContextValues['handleSubmit']
): handleSubmit is GynecologicalInterviewPregnancyCompletionFormController['handleSubmit'] =>
   pregnancyCompletionTypes.some((completionType) => completionType === interviewType);

export type GynecologicalInterviewFormPartVisitor = {
   visitRegularInterview: () => JSX.Element;
   visitPatientPregnantInterview: () => JSX.Element;
   visitPregnancyCompletionInterview: () => JSX.Element;
};

export const renderGynecologicalInterviewFormPart = (
   interviewType: GynecologicalInterviewType | null,
   visitor: GynecologicalInterviewFormPartVisitor
): JSX.Element => {
   switch (interviewType) {
      case 'REGULAR_INTERVIEW':
      case null:
         return visitor.visitRegularInterview();
      case 'PATIENT_PREGNANT':
         return visitor.visitPatientPregnantInterview();
      case 'DELIVERY':
      case 'DEAD_DELIVERY':
      case 'MISCARRIAGE':
      case 'OTHER':
         return visitor.visitPregnancyCompletionInterview();
      default:
         return assertUnreachable(interviewType);
   }
};
